import React, {useState, useEffect} from 'react';
import {StyleSheet} from 'react-native';
import {Box} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import DetailSection from './Section';
import HeaderSection from './Header';
import InternalTemplate from '../../../../../components/templates/internal';
import {StackParamList} from '../../../../../navigators';
import {message} from '../../../../../utils/messages';
import {PrimaryButton} from '../../../../../components/buttons';
import {IBalanceDetail} from '../../../../../interfaces/dtos';
import {useContextState} from '../../../../../context/user';
import {SpinnerModal} from '../../../../../components/modals';
import {ResultState, CurrencyType} from '../../../../../constants/enumerations';
import useToast from '../../../../../hooks';

type ScreenProps = NativeStackScreenProps<StackParamList, 'BalanceDetail'>;

const BalanceDetailScreen = ({navigation, route}: ScreenProps) => {
  const [detail, setDetail] = useState(null as IBalanceDetail | null);
  const {sendEmailBalance} = useContextState();
  const {showServerError} = useToast();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setDetail(route.params);
  }, [route.params]);

  const handleGoBack = () => {
    navigation.pop(1);
  };

  const handleSendDetail = async () => {
    if (detail) {
      setIsLoading(true);
      const result = await sendEmailBalance(detail.id, detail.type.code);
      setIsLoading(false);
      if (result === ResultState.success) {
        navigation.navigate('SendSuccess');
      } else {
        showServerError();
      }
    }
  };

  if (detail == null) {
    return <></>;
  }

  return (
    <InternalTemplate
      title={'screen-balance-detail-title'}
      contentPaddingX="0"
      backButton={{
        label: 'back-balance-list',
        onPress: () => handleGoBack(),
        usage: 'external',
      }}>
      <>
        <SpinnerModal
          show={isLoading}
          title={message('send-proof-loading-title')}
        />
        <HeaderSection detail={detail} />
        <DetailSection
          currency={CurrencyType.foreign}
          total={detail.fullInfo.foreign.total}
          balance={detail.fullInfo.foreign.value}
          paidOut={detail.fullInfo.foreign.paidOut}
          style={styles.foreignSection}
          backgroundColor={'#F8F8F8'}
        />
        <DetailSection
          currency={CurrencyType.local}
          total={detail.fullInfo.local.total}
          balance={detail.fullInfo.local.value}
          paidOut={detail.fullInfo.local.paidOut}
          style={styles.localSection}
        />
        <Box paddingX="10%" mt={10}>
          <PrimaryButton
            label="balance-detail-send-to-email"
            onPress={() => handleSendDetail()}
          />
        </Box>
      </>
    </InternalTemplate>
  );
};

const styles = StyleSheet.create({
  foreignSection: {
    marginTop: 25,
  },
  localSection: {marginTop: 5},
});

export default BalanceDetailScreen;
